import React from 'react';
import './Expertises.css';

const Expertises = () => {
    return (
        <div className="aboutus-container">
            <h1 className="aboutus-title">Nos Expertises</h1>

            <div className="aboutus-flex">
                <div className="aboutus-popup-area">
                    <div className="expertises-content">
                        <p>
                            Chez H'ART ÉLÉGANCE, l'expertise naît d'une compréhension profonde : lire ce que le corps exprime, comprendre ses origines, révéler son architecture.
                        </p>

                        <h3>Nos Cinq Disciplines</h3>

                        <h4>• Morphologie Émotionnelle — Lire</h4>
                        <p>L'art de décrypter ce que le corps exprime avec précision et profondeur. Chaque posture, chaque ligne, chaque tension révèle une histoire émotionnelle précise. C'est la porte d'entrée de toute révélation.</p>

                        <h4>• Fils Émotionnels — Comprendre</h4>
                        <p>Le métier à tisser des dynamiques intérieures — chaque émotion, un fil de l'architecture. Chaque émotion est un fil précieux qui révèle le tissage subtil entre histoire intérieure et manifestations visibles dans la présence.</p>

                        <h4>• Architecture de l'Être — Révéler</h4>
                        <p>L'organisation harmonieuse de la présence — cohérence entre posture, expression et essence. C'est ici que l'être reconnaît sa propre structure et l'habite pleinement.</p>

                        <h4>• Stylistique de l'Élégance — Exprimer</h4>
                        <p>L'art d'aligner la présence extérieure avec la réalité intérieure. Allier posture, gestuelle, allure et expression pour une élégance singulière et incarnée.</p>

                        <h4>• Présence Intemporelle — Habiter</h4>
                        <p>L'authenticité durable d'une personne qui s'habite pleinement. Une présence magnétique, authentique et intemporelle — qui traverse les modes et les circonstances.</p>

                        <h3>Pour qui ?</h3>
                        <p>Nos services s'adressent à celles et ceux qui exigent l'excellence et la profondeur :</p>
                        <ul>
                            <li>Décideurs et personnalités recherchant une présence à la hauteur de leur stature.</li>
                            <li>Artistes et créateurs désirant exprimer leur singularité avec force.</li>
                            <li>Ceux qui cherchent non pas à changer, mais à se reconnaître et à s'habiter pleinement.</li>
                        </ul>

                        <h3>Partenariats & Collaborations</h3>
                        <p>H'ART ÉLÉGANCE développe des partenariats avec des maisons, des institutions et des acteurs exigeants du luxe et de l'art. Chaque collaboration est pensée pour créer des expériences rares, authentiques et sur mesure.</p>

                        <h3>Rencontre confidentielle & Tarifs</h3>
                        <p>Chaque prestation est entièrement personnalisée selon votre demande, votre histoire et vos aspirations. Nos tarifs sont établis sur mesure, adaptés à la nature et au détail de votre demande.</p>

                        <h3>Demander un Entretien Stratégique Confidentiel</h3>
                        <p>Les rencontres avec la Maison sont confidentielles et menées avec discernement, confidentialité et justesse. Écrivez-nous pour explorer ensemble ce qu'une lecture de votre présence peut révéler.</p>
                    </div>
                </div>
            </div>
            <div className="aboutus-bg-bling">
                <div className="aboutus-bling bling1"></div>
                <div className="aboutus-bling bling2"></div>
                <div className="aboutus-bling bling3"></div>
                <div className="aboutus-bling bling4"></div>
            </div>
        </div>
    );
};

export default Expertises;
